<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import { authProtectedRoutes } from '@routes'

export default {
  components: {},
  props: {
    mode: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
        menuItems: authProtectedRoutes,
        isAdmin: false,
    }
  },
  computed: {
      ...authComputed,
      session_user_item(){
          let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
          let user = session.user ? session.user : null;
          return user;
      },
  },
  mounted: function() {

    if(this.session_user_item && this.session_user_item.role == 'administrator'){
        this.isAdmin = true;
    }

    // eslint-disable-next-line no-unused-vars
    var menuRef = null

    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    let links = document.getElementsByClassName('side-nav-link-ref')
    let matchingMenuItem = null

    for (let i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].getAttribute('data-path')) {
            matchingMenuItem = links[i]
            break;
        }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.$parent.toggleMenu()
    },
    nav(route){
        this.toggleMenu();
        this.$router.push({ path: route});
        return false;
    },
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0
        : false
    },
  },
}
</script>

<template>
    <ul id="side-menu" class="metismenu">

        <!-- <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/dashboard')" data-path="/account/dashboard" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-chart-pie-alt"></i><span>Дашборд</span>
            </a>
        </li> -->

        <li class="side-nav-title side-nav-item">
            <!-- <hr/> -->
            <p class="menu-title mb-0" style="margin-top: 20px">Документы</p>
            <a href="javascript:void(0)" @click="nav('/account/sales')" data-path="/account/sales" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-cart"></i><span>Продажи</span>
            </a>            
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/orders')" data-path="/account/orders" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-shopping-cart-alt"></i><span>Заказы</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/purchases')" data-path="/account/purchases" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-truck-loading"></i><span>Закупки</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/movings')" data-path="/account/movings" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-truck"></i><span>Перемещения</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Финансы</p>
            <a href="javascript:void(0)" @click="nav('/account/finance/payin')" data-path="/account/finance/payin" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-arrow-down-right"></i><span>Доходы</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/finance/payout')" data-path="/account/finance/payout" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-arrow-up-right"></i><span>Расходы</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/finance/moving')" data-path="/account/finance/moving" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-exchange"></i><span>Перемещения</span>
            </a>
        </li>
        <!-- <li class="side-nav-title side-nav-item">
          <a href="javascript:void(0)" @click="nav('/account/costs')" data-path="/account/costs" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-money-insert"></i><span>Затраты</span>
          </a>
        </li> -->

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Отчеты</p>
            <a href="javascript:void(0)" @click="nav('/account/reports/orders')" data-path="/account/reports/orders" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-file-download-alt"></i><span>Заказы</span>
            </a>
        </li>        
        <li class="side-nav-title side-nav-item">
          <a href="javascript:void(0)" @click="nav('/account/reports/warehouses')" data-path="/account/reports/warehouses" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-parcel"></i><span>Склад</span>
          </a>
        </li>
        <li class="side-nav-title side-nav-item">
          <a href="javascript:void(0)" @click="nav('/account/reports/finance')" data-path="/account/reports/finance" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-exchange"></i><span>Движение денежных средств</span>
          </a>
        </li>

        <!-- <li class="side-nav-title side-nav-item">
          <a href="javascript:void(0)" @click="nav('/account/planned')" data-path="/account/planned" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-calculator-alt"></i><span>Планирование</span>
          </a>
        </li>         -->

        <!-- <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Финансы</p>
            <a href="javascript:void(0)" @click="nav('/account/finance')" data-path="/account/finance" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-exchange"></i><span>ДДС</span>
            </a>
        </li> -->
<!--   
        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Отчеты</p>            
            <a href="javascript:void(0)" @click="nav('/account/reports/odds')" data-path="/account/reports/odds" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-exchange"></i><span>ОДДС</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/reports/plane')" data-path="/account/reports/plane" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-chart-growth-alt"></i><span>План/факт</span>
            </a>
        </li> -->

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Справочники</p>
            <a href="javascript:void(0)" @click="nav('/account/counterparties')" data-path="/account/counterparties" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-briefcase-alt"></i><span>Контрагенты</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <a
                href="javascript:void(0);"
                class="side-nav-link"
                style="font-size: 14px;"
            >
                <i class="feather uil uil-box"></i>Товары
                <span class="menu-arrow"></span>
            </a>

            <ul class="nav-second-level">
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/products/categories')" data-path="/account/products/categories" class="side-nav-link side-nav-link-ref">
                        <span>Категории товаров</span>
                    </a>
                </li>
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/products')" data-path="/account/products" class="side-nav-link side-nav-link-ref">
                        <span>Номенклатура</span>
                    </a>
                </li>
            </ul>
        </li>

        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/brands')" data-path="/account/brands" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-star"></i><span>Бренды</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/countries')" data-path="/account/countries" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-map"></i><span>Страны</span>
            </a>
        </li>        
        <!-- <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/costs/items')" data-path="/account/costs/items" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-sort-amount-down"></i><span>Статьи затраты</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/planned/indicators')" data-path="/account/planned/indicators" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-crosshair"></i><span>Плановые показатели</span>
            </a>
        </li> -->
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/currency')" data-path="/account/currency" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-usd-circle"></i><span>Валюты</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/units')" data-path="/account/units" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-label-alt"></i><span>Единицы измерений</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Компания</p>
            <a href="javascript:void(0)" @click="nav('/account/companies')" data-path="/account/companies" class="side-nav-link side-nav-link-ref">
              <i class="feather uil uil-building"></i><span>Компании</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/bank/accounts')" data-path="/account/bank/accounts" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-wallet"></i><span>Счета</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/warehouses')" data-path="/account/warehouses" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-archive-alt"></i><span>Склады</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Настройки</p>
            <a href="javascript:void(0)" @click="nav('/account/users')" data-path="/account/users" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-users-alt"></i><span>Пользователи</span>
            </a>
        </li>
        <!-- <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/users/accounts')" data-path="/account/users/accounts" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-usd-square"></i><span>Аккаунты</span>
            </a>
        </li>     -->
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/finance/types')" data-path="/account/finance/types" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-exchange"></i><span>Категории операций</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
        <a href="javascript:void(0)" @click="nav('/account/integrations')" data-path="/account/integrations" class="side-nav-link side-nav-link-ref">
            <i class="feather uil uil-share-alt"></i><span>Интеграции</span>
        </a>
        </li>
    </ul>

</template>

<style>
    .side-nav-link .uil{
        margin-right: 12px !important;
    }
    #sidebar-menu > ul > li > a span {
        font-size: 14px;
    }
</style>